import { defineMessages } from 'react-intl'

const messages = {
  title: defineMessages({
    default: {
      id: 'landingPage.ownEveryMile.title.default',
      defaultMessage: 'Own Every Workout',
    },
    run: {
      id: 'landingPage.ownEveryMile.title.run',
      defaultMessage: 'Own Every Mile',
    },
    walk: {
      id: 'landingPage.ownEveryMile.title.walk',
      defaultMessage: 'Own Every Mile',
    },
    hike: {
      id: 'landingPage.ownEveryMile.title.hike',
      defaultMessage: 'Own Every Trail',
    },
    ride: {
      id: 'landingPage.ownEveryMile.title.ride',
      defaultMessage: 'Own Every Ride',
    },
  }),
  caption: defineMessages({
    default: {
      id: 'landingPage.ownEveryMile.caption.default',
      defaultMessage: 'The best mobile fitness tracking experience, backed by the world\'s largest digital health and fitness community.',
    },
    run: {
      id: 'landingPage.ownEveryMile.caption.run',
      defaultMessage: 'The best mobile run tracking experience, backed by the world\'s largest digital health and fitness community.',
    },
    walk: {
      id: 'landingPage.ownEveryMile.caption.walk',
      defaultMessage: 'The best mobile walk tracking experience, backed by the world\'s largest digital health and fitness community.',
    },
    hike: {
      id: 'landingPage.ownEveryMile.caption.hike',
      defaultMessage: 'The best mobile hike tracking experience, backed by the world\'s largest digital health and fitness community.',
    },
    ride: {
      id: 'landingPage.ownEveryMile.caption.ride',
      defaultMessage: 'The best mobile ride tracking experience, backed by the world\'s largest digital health and fitness community.',
    },
  }),
}

export default messages
